export default {
  id: null,
  companyID: null,
  areaID: null,
  name: null,
  cnpj: null,
  description: null,
  status: null,
  dateUpdate: null,
  accountIDUpdate: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configuration/insurancemodel.js